import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { CONNECTION_TYPES } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
/**
 * list Connection Type.
 * @returns {Promise} - A promise that resolves with the list of Connection Type or rejects with an error.
 * @param props
 */
export const listConnectionTypes = async ({
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
  systemType,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${CONNECTION_TYPES.replace('{sysType}', doubleEncode(systemType?.SysType))}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    connectionTypes: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Connection Type.
 * @returns {Promise} - A promise that resolves with the creation of integration type or rejects with an error.
 * @param data
 */
export const createConnectionType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${CONNECTION_TYPES.replace('{sysType}', doubleEncode(data?.SysType))}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Connection Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const updateConnectionType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${CONNECTION_TYPES.replace('{sysType}', doubleEncode(data?.SysType))}/${data?.SystemConnTypeId}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Delete Connection Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const deleteConnectionType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${CONNECTION_TYPES.replace('{sysType}', doubleEncode(data?.SysType))}/${data?.SystemConnTypeId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Get Connection Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const getConnectionType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${CONNECTION_TYPES.replace('{sysType}', doubleEncode(data?.SysType))}/${data?.SystemConnTypeId}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
